import { Table, TBody, TD, TR } from 'oy-vey';
import PropTypes from 'prop-types';
import React from 'react';
import { sitename, url } from '../../../config';
import Layout from '../layouts/Layout';
import EmptySpace from '../modules/EmptySpace';
import Footer from '../modules/Footer';
import Header from '../modules/Header';

class NewInquiry extends React.Component {
  static propTypes = {
    content: PropTypes.shape({
      receiverName: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      threadId: PropTypes.number.isRequired,
      title: PropTypes.number.isRequired,
    }).isRequired,
  };

  render() {
    const textStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
      padding: '35px',
    };

    const btnCenter = {
      textAlign: 'center',
    };

    const buttonStyle = {
      margin: 0,
      fontFamily: 'Proxima Nova',
      padding: '10px 16px',
      textDecoration: 'none',
      borderRadius: '2px',
      border: '1px solid',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontWeight: 'bold',
      fontSize: '18px',
      whiteSpace: 'nowrap',
      background: '#ffffff',
      borderColor: '#35BAEF',
      backgroundColor: '#35BAEF',
      color: '#ffffff',
      borderTopWidth: '1px',
    };

    const {
      content: { receiverName, message, threadId, title },
    } = this.props;

    let messageURL = url + '/inbox/' + threadId;

    return (
      <Layout>
        <Header color="#159CE9" backgroundColor="#F7F7F7" />
        <div>
          <Table width="100%">
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <div>Hi {receiverName},</div>
                  <EmptySpace height={20} />
                  <div>You have a new message about your {title}.</div>
                  <EmptySpace height={20} />
                  <div>Message:</div>
                  <EmptySpace height={10} />
                  <div>{message}</div>
                  <EmptySpace height={40} />
                  <div style={btnCenter}>
                    <a href={messageURL} style={buttonStyle}>
                      Check it out
                    </a>
                  </div>
                  <EmptySpace height={40} />
                  <div>
                    Thanks, <br />
                    The {sitename} Team
                  </div>
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={40} />
        </div>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }
}

export default NewInquiry;



// WEBPACK FOOTER //
// ./src/core/email/template/NewInquiry.js